   <!-- Header HTML Start -->
   <app-header></app-header>
   <!-- Header HTML End -->
  <div class="layout-content">
      <router-outlet></router-outlet>
  </div>
  <!-- Footer HTML Start -->
  <app-after-login-footer></app-after-login-footer>
  <!-- Footer HTML End -->